module.exports = __webpack_public_path__ + "static/media/image_13.fb2f7853.png";